/**
 * Le retour au premier plan : `visibilitychange` vers `visible` (l'app rouverte depuis le
 * tiroir des tâches, l'onglet repris, l'écran rallumé). Une PWA ou une WebView mise en arrière-
 * plan garde sa page montée, donc ses données du dernier chargement : sans ce branchement, ce
 * qui a changé ailleurs (depuis l'ordi) n'apparaît pas tant qu'on ne tire pas la liste.
 *
 * Un seul appel en vol : des allers-retours rapides n'empilent pas les lectures. `bloque` tait
 * la relecture tant qu'elle écraserait un travail en cours (une modale ouverte reconstruit son
 * brouillon quand la tâche du store change : ce qui était tapé serait perdu).
 */
export interface Visibilite extends EventTarget {
  readonly visibilityState: DocumentVisibilityState;
}

export function brancherRetourPremierPlan(
  doc: Visibilite,
  onVisible: () => Promise<void>,
  bloque: () => boolean = () => false
): () => void {
  let enVol = false;
  const surChangement = (): void => {
    if (doc.visibilityState !== 'visible' || enVol || bloque()) return;
    enVol = true;
    onVisible()
      .catch(() => undefined)
      .finally(() => {
        enVol = false;
      });
  };
  doc.addEventListener('visibilitychange', surChangement);
  return () => doc.removeEventListener('visibilitychange', surChangement);
}
